export default __webpack_public_path__ + "static/media/loading-bubbles.d0251100.svg";